module.exports = __webpack_public_path__ + "static/media/logo_with_text.3bd98db8.svg";